// src/pages/Home.jsx
// 콜드 트래픽(유튜브 유입) 전환용 랜딩 — 가치 한 줄 + 단일 무료 CTA + 출력물 샘플 + 3스텝.
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PAID_CLOSED } from '../utils/siteMode.js';

import { useAuth } from '../hooks/useAuth.js';
import { useCountry } from '../contexts/CountryContext.jsx';
import SEO from '../components/SEO.jsx';

// 국가별 "출력물 샘플" — 각 국가 채널의 최고 조회 쇼츠 (실제 결과물 미리보기)
const SAMPLE_BY_COUNTRY = { KR: 'nRt12ud2n4U', US: 'j91ojgIwm0c', JP: 'sA_IuvrCIPQ' };

export default function Home() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { country, config } = useCountry();
  const sampleId = SAMPLE_BY_COUNTRY[country] || SAMPLE_BY_COUNTRY.KR;

  return (
    <div className="max-w-3xl mx-auto px-4 py-12 text-center">
      <SEO title={t('appName')} description={t('home.seoDescription')} path="/" />

      <div className="text-4xl mb-3">{config.flag} 🎙️</div>
      <h1 className="text-3xl md:text-4xl font-extrabold leading-tight mb-3">
        {t('home.heroTitle')}
      </h1>
      <p className="text-base md:text-lg text-gray-600 mb-7 max-w-xl mx-auto">
        {t('home.heroSub')}
      </p>

      {/* 단일 주 CTA */}
      <Link
        to={user ? '/create' : '/register'}
        className="btn-primary text-lg px-8 py-3 inline-block"
      >
        {user ? `🎬 ${t('nav.create')}` : `⚡ ${t('home.ctaStart')}`}
      </Link>
      {!user && (
        <p className="mt-3 text-sm text-gray-500">
          <Link to="/login" className="underline hover:text-gray-700">{t('home.loginPrompt')}</Link>
        </p>
      )}

      {/* 출력물 샘플 — 실제로 뭘 만드는지 1초 안에 보여줌 */}
      <p className="mt-10 mb-3 text-sm font-semibold text-gray-700">{t('home.sampleCaption')}</p>
      <div className="mx-auto w-full max-w-[260px] aspect-[9/16] rounded-2xl overflow-hidden shadow-lg border bg-black">
        <iframe
          className="w-full h-full"
          src={`https://www.youtube-nocookie.com/embed/${sampleId}`}
          title="CitizenCast sample"
          loading="lazy"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>

      {/* 3스텝 */}
      <h2 className="mt-14 mb-5 text-lg font-bold">{t('home.stepsTitle')}</h2>
      <div className="grid sm:grid-cols-3 gap-4 text-left">
        {['step1', 'step2', 'step3'].map((k, i) => (
          <div key={k} className="card">
            <div className="text-xl font-extrabold" style={{ color: 'var(--color-primary)' }}>{i + 1}</div>
            <p className="text-sm text-gray-700 mt-1">{t(`home.${k}`)}</p>
          </div>
        ))}
      </div>

      <div className="mt-10">
        <Link
          to={user ? '/create' : '/login'}
          className="btn-primary px-8 py-3 inline-block"
        >
          {user ? `🎬 ${t('nav.create')}` : `⚡ ${t('home.ctaStart')}`}
        </Link>
        {!PAID_CLOSED && (
          <p className="mt-4 text-xs text-gray-400">
            <Link to="/pricing" className="underline hover:text-gray-600">{t('nav.pricing')}</Link>
          </p>
        )}
      </div>
    </div>
  );
}
